module.exports = __webpack_public_path__ + "static/media/1_A1_19.007ec6bf.png";